

import ButtonComp from "./ButtonComp.tsx";
import useH5Config from "../../h5/config/useH5Config.tsx"
import useConnectBscWallet from "../../h5/config/useConnectBscWallet.tsx"
import PromptDialog from "../PromptDialog.tsx";
import { useTranslation } from "react-i18next";

interface Props {
    callback?: (val: string) => void
}
const ConnectWallet = ({ callback }: Props) => {
    const { t } = useTranslation();
    const { setShowBscSign } = useConnectBscWallet()


    return (


        <PromptDialog title={t("other.attention")} lineBreak={true} teleport={document.querySelector('body')} isClose={false} dialog={true} setDialog={() => {
            setShowBscSign(false)
        }} text={''}>
            <p>{t("h5.text4")}</p>
            <p className="mt-[20px]">{t("h5.text5")}</p>
            <div className="grid grid-cols-2 gap-4 mt-[20px]">
                <ButtonComp width={120} title={t("other.cancel")} callBack={() => { callback && callback('cancel') }}></ButtonComp>
                <ButtonComp width={120} title={t("create_arena.continue")} callBack={() => { callback && callback('continue') }}></ButtonComp>
            </div>

        </PromptDialog>

    )
}

export default ConnectWallet